import { BillingTier } from "../../__generated__/gql/graphql";
import { UserContextType } from "./UserContext";

const defaultUserContext: UserContextType = {
  isReady: false,
  isError: false,
  user: undefined,
  tenant: undefined,
  usageForCurrentPeriod: {
    articles: 0,
  },
  keywordQueryUsageForCurrentPeriod: {
    keywordQueries: 0,
  },
  billingInfo: {
    billingTier: BillingTier.Free,
    downgradeBillingTier: undefined,
    currentPeriodEnd: new Date().toISOString(),
    currentPeriodStart: new Date().toISOString(),
    currentMonthEnd: new Date().toISOString(),
    currentMonthStart: new Date().toISOString(),
    credits: 0,
    articlesPerMonth: 0,
    creditsUsed: 0,
    freeCreditsIssued: 0,
    keywordQueryCredits: 0,
    keywordQueriesPerMonth: 0,
    keywordQueryCreditPrice: 0,
    pricePerArticle: 0,
    imagesPerArticleLimit: 0,
    scrapeLimit: 0,
    linkedTeamsLimit: 0,
    subscriptionPrice: 0,
  },
  userOrganizations: [],
  articlesRemaining: 0,
  keywordQueryCreditsRemaining: 0,
  signOut: () => {},
  selectOrganization: async () => {},
};

export default defaultUserContext;
